import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import style from './loadConfiguration.scss';
import CaravanConfigurationApi from '../../services/apis/caravanConfiguration';
import ConfigurationActions from '../../redux/configurationRedux';
import ShownStepsActions from '../../redux/shownStepsRedux';


class LoadConfigurationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { configurationCode: '', showInput: false };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    onToggleDialog = () => this.setState({ showInput: !this.state.showInput });

    onLoadConfiguration = () => {
        const configurationCode = this.state.configurationCode;
        this.forceLoadConfiguration(configurationCode);
    };

    forceLoadConfiguration = (configurationCode) => {
        if (configurationCode === '' || configurationCode === null) {
            return;
        }
        const configuration = CaravanConfigurationApi.load(configurationCode);
        configuration.configuration.then(data => {
            this.props.setCaravan(data.data.data.configuration.caravan);
            this.props.setModel(data.data.data.configuration.model);
            this.props.setConfiguration(data.data.data.configuration.configurations);
            this.props.setFormData(data.data.data.configuration.formData);
            this.props.navigateToConclusion();
        });
    };

    handleInputChange = () => {
        this.setState({ configurationCode: event.target.value });
    };

    renderInput = () => (
        <div className={style.container}>
            <div className={style.inputBackground} onClick={() => this.onToggleDialog()} />
            <div className={style.inputContainer}>
                <div className={style.loadDialog}>
                    <div className={style.inputLabel}>
                        <p>
                            {t`Bitte geben Sie Ihren Code ein und klicken Sie auf \"Konfiguration laden\"`}
                        </p>
                    </div>
                    <input type="text" value={this.state.configurationCode} onChange={this.handleInputChange} className={style.codeInput} />
                    <button
                        className={style.loadButton}
                        onClick={() => this.onLoadConfiguration()}
                    >
                        <span>{t`Konfiguration laden`}</span>
                    </button>
                </div>
            </div>
        </div>
    );
    render = () => (
        <div className={style.container}>
            <button
                className={style.openDialogButton}
                onClick={() => this.onToggleDialog()}
            >
                <span>{t`Konfiguration laden`}</span>
            </button>
            { this.state.showInput ? this.renderInput() : null }
        </div>
    );
}

const mapStateToProps = state => ({
    configuration: state.configuration,
});

const mapDispatchToProps = dispatch => ({
    setCaravan: caravan => dispatch({
        type: 'SET_CARAVAN',
        caravan,
    }),
    setModel: model => dispatch({
        type: 'SET_MODEL',
        model,
    }),
    setConfiguration: configurations => dispatch({
        type: 'SET_CONFIGURATIONS',
        configurations,
    }),
    setFormData: formData => dispatch(
        ConfigurationActions.setFormData(formData)
    ),
    navigateToConclusion: () => {
        for (let stepId = 1; stepId < 8; stepId += 1) {
            dispatch(ShownStepsActions.addShownStep(stepId));
        }
        dispatch({
            type: 'NAVIGATE',
            step: 8,
        });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadConfigurationComponent);
